/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Aperçu',
    lead: 'Indicateurs clés de la plateforme : revenus, entreprises et utilisateurs actifs, et rétention.',
    activeCompanies: 'Entreprises actives',
    activeUsers: 'Utilisateurs actifs',
    revenueThisMonth: 'Revenus ce mois-ci',
    retention: 'Rétention (mois sur mois)',
    retentionUnavailable: 'Pas encore de données',
    retentionDetail: '{{retained}} entreprises conservées sur {{total}}',
  },
} as const;
